import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import { ManRadioButtonGroup, ManRadioButton, ManText, ManCard } from '@craft-design-system/core-components-react';
import ifav from './ifav.png';
import Zoom from '../Zoom';
import { Button, Popover, OverlayTrigger } from 'react-bootstrap';

const Charging_power_normal = ({ value }) => {
  const [ChargingPowerNormal, setChargingPowerNormal] = useState(null);

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        <strong>Definition:</strong><br />
        Overview on average charging power vs. average battery temperature (system) for each normal charging cycle since start of data acquisition.<br /><br />

        <strong>Telematic raw data for this KPI:</strong><br />
        TBM3:<br />
        • chargedenergy<br />
        • energylevel<br />
        • signal_timestamp<br />
        • batterytemperature<br />
        CM4:<br />
        • chargedenergy<br />
        • batchgdenergycbp<br />
        • energylevel<br />
        • energylevelcbp<br />
        • signal_timestamp<br />
        • batterytemperature<br /><br />

        <strong>Time series data:</strong><br />
        Days without data are not taken into account for the calculation.
      </Popover.Body>
    </Popover>
  );

  useEffect(() => {
    try {
      setChargingPowerNormal(JSON.parse(value));
    } catch (error) {
      console.error("Error parsing JSON", error);
    }
  }, [value]);

  return (
    

    <div style={{ padding: '16px' }}>
    {/* Title + Info */}
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '8px',
      gap: '8px'
    }}>
      <div style={{
        flex: 1,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '100px'
      }}>
        <ManText
          className="card-title-text"
          variant="component-l"
          as="span"
          size="l"
          style={{ lineHeight: 'normal' }}
        >
         Charging power (system) vs battery temperature (system) during normal charging
        </ManText>
      </div>
      <div style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        flexDirection: "row-reverse"
        // margingtop: 30
      }}>
        {/* <PopoverComponent
          id="charging_time"
          content={tooltipContent}
        /> */}
        <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
          <img className="man-logovv1" src={ifav} alt="info" />
        </OverlayTrigger>
        <Zoom
          chartData={ChargingPowerNormal?.data}
          chartLayout={ChargingPowerNormal?.layout}
          chartTitle="Charging power (system) vs battery temperature (system) during normal charging"
        />
        {/* <DownloadButtonComponent
          data={downloadData}
          fileName={`charging_energy_${chartType.toLowerCase()}_${radio_buttons_test?.["Charging Energy"]?.toLowerCase() || "daily"}.xlsx`}
        /> */}
      </div>
    </div>

    

      {ChargingPowerNormal && (
        <Plot
          data={ChargingPowerNormal.data}
          layout={{
            ...ChargingPowerNormal.layout,
            autosize: true,
            responsive: true,
            margin: { t: 10, r: 10, l: 10, b: 150 }
          }}
          style={{ width: '100%',  height: '500px' }}
          useResizeHandler={true}
        />
      )}
    </div>
  );
};

Charging_power_normal.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Charging_power_normal;